import React from 'react'
import PropTypes from 'prop-types'

import MainFirst from './../block/MainFirst'
import ShortInfo from './../block/ShortInfo'
import CircleCardsSlyder from './../block/CircleCardsSlyder'
import Cards1 from './../block/Cards1'
import PosmotriteVideo from './../block/PosmotriteVideo'
import Ruchkibezopasnost from './../block/Ruchkibezopasnost'
import PhotoGallarySlyder from './../block/PhotoGallarySlyder'
import Raschet from './../block/Raschet'
import Kontakti from './../block/Kontakti'

class Ruchki extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <MainFirst
          data={data?.main_first || {}}
          protocol={protocol}
          assets_path={assets_path}
        />
        <ShortInfo
          data={data?.short_info || {}}
          assets_path={assets_path}
        />
        <CircleCardsSlyder
          data={data?.circlecards1 || {}}
          variant={2}
        />
        <Cards1
          list={data?.priemushestva || []}
          title={data?.priemushestva_title || ``}
          margin={`bottom`}
          button={{
            text: `Получить каталог`,
            width: 198
          }}
        />
        <PosmotriteVideo
          data={data?.videos || {}}
          assets_path={assets_path}
          margin={`bottom`}
        />
        <CircleCardsSlyder
          title={`Стандартные <span>ручки</span>`}
          rtext={`[Функциональные ручки для повседневных задач]`}
          data={data?.circlecards2 || {}}
          className={`top-50`}
          imageSize={{
            width: 145,
            height: 165
          }}
        />
        <Ruchkibezopasnost
          title={`Базовые решения <span>и ручки с ключом</span>`}
          rtext={`[Безопасность и удобство в каждой детали]`}
          list={data?.ruchki?.list}
          image={data?.ruchki?.image}
        />
        <PhotoGallarySlyder
          data={data?.photogallary || {}}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
          cardsOnly={true}
        />
      </>
    )
  }
}

Ruchki.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Ruchki.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Ruchki